const Parents = () => import("./views/Parents.vue");
const ParentEdit = () => import("./views/ParentEdit.vue");
const Parent = () => import("./views/Parent.vue");
const ParentChildEdit = () => import("./views/ParentChildEdit.vue");
const ParentChildren = () => import("./views/ParentChildren.vue");

const route = "/parents";

export default [
  {
    path: route,
    name: "parents.list",
    component: Parents,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/create`,
    name: "parents.create",
    component: ParentEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },

  {
    path: `${route}/:parentId`,
    name: "parents.details",
    component: Parent,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/:parentId/edit`,
    name: "parents.edit",
    component: ParentEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN"],
    },
  },

  {
    path: `${route}/:parentId/children`,
    name: "parents.children.list",
    component: ParentChildren,
    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN", "ROLE_PARENT"],
    },
  },

  {
    path: `${route}/:parentId/children/create`,
    name: "parents.children.create",
    component: ParentChildEdit,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN", "ROLE_PARENT"],
    },
  },

  {
    path: `${route}/:parentId/children/:childId/edit/:backContext?`,
    name: "parents.children.edit",
    component: ParentChildEdit,

    props: true,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN", "ROLE_PARENT"],
    },
  },
];
